export const extractUrl = (str: string) => {
  return str.replace(/.*(https?:\/\/[^\s]+).*/, '$1')
}

export const extractUrlOpt = (str: string | undefined) => {
  return str != null ? extractUrl(str) : undefined
}
